<template>
    <div>
        <div class="tabs">
            <ul>
                <li v-for="tab in tabs" :key="tab.id" :class="{ 'is-active': activeContentTab === tab.id }">
                    <a @click="activeContentTab = tab.id">{{ tab.name }}</a>
                </li>
            </ul>
        </div>
        <div>
            <p v-html="content"></p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activeContentTab: ''
        };
    },
    computed: {
        descriptions() {
            return this.item.localizations.filter((localization) => localization.key === 'description');
        },
        tabs() {
            const tabs = this.descriptions.sort((a, b) => a.locale_id - b.locale_id)
                .map((description) => {
                    return {
                        id: `description-${description.locale_id}`,
                        name: `Beskrivelse (${description.locale?.code.toUpperCase()})`,
                        content: nl2br(description.value),
                    };
                });

            tabs.push({
                id: 'note',
                name: 'Noter',
                content: this.item.note,
            });

            return tabs;
        },
        content() {
            if (!this.activeContentTab) {
                this.activeContentTab = this.tabs[0].id;
            }

            return this.tabs.find((tab) => tab.id === this.activeContentTab).content;
        },
    },
    watch: {
        item() {
            this.activeContentTab = this.tabs[0].id;
        },
    }
}
</script>

<style scoped>
.tabs {
    margin-top: 10px;
}
</style>
